/* unplugin-vue-components disabled */import script from "./PBBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./PBBadge.vue?vue&type=script&setup=true&lang=js"

import "./PBBadge.vue?vue&type=style&index=0&id=7c2d9026&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c2d9026"]])

export default __exports__